import React from 'react';
import {view, css} from '@sail/ui';
import type {Intent} from '@sail/engine';

type Props = {
  styles?: Intent[];
};

const boxSizingReset = css.global({
  '*': {
    boxSizing: 'border-box',
  },
});

/**
 * Sail assumes that all elements have border-box sizing
 */
export const BorderBoxContainer: React.FC<Props> = ({
  children,
  styles = [],
}) => <view.div uses={[...styles, boxSizingReset]}>{children}</view.div>;
